import { useEffect } from 'react';
import { StyledManageCookiesContainer } from './ManageCookies.styles';
import enviro from 'enviro';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageCookies = () => {
  const isCookieBannerOnPage = document.getElementsByClassName('cookie-banner-top-static').length > 0;
  const isQA = enviro.isQa();
  if (!isCookieBannerOnPage && isQA) {
    console.warn('Cookie banner script is not loaded on this page, the ManageCookies component will not render');
  }
  useEffect(() => {
    try {
      const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');
      if (hiddenFooterCookieSettings && window._hsg.compliance) {
        window._hsg.compliance.addSettingsLink();
      }
    } catch (error) {
      console.log('Error loading Manage Cookies link');
    }
  }, []);
  return /*#__PURE__*/_jsx(StyledManageCookiesContainer, {
    children: /*#__PURE__*/_jsx("div", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: /*#__PURE__*/_jsx(Link, {
        href: "#"
      })
    })
  });
};